var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIcnIn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    alt: "linkedIn",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_in",
    transform: "translate(-2750 -6107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Group_28",
    "data-name": "Group 28",
    d: "M8.288,16.223V9.385H6.16v6.838ZM7.213,8.47A1.25,1.25,0,0,0,8.448,7.212,1.224,1.224,0,0,0,6,7.212,1.245,1.245,0,0,0,7.213,8.47Zm9.015,7.753h.023V12.472c0-1.83-.412-3.247-2.562-3.247a2.28,2.28,0,0,0-2.013,1.1h-.023V9.385H9.615v6.838h2.128V12.838c0-.892.16-1.738,1.258-1.738s1.121,1.006,1.121,1.807v3.316Z",
    transform: "translate(2747 6104)",
    fill: "rgba(102,102,102,0.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 16,
    height: 16,
    transform: "translate(2750 6107)",
    fill: "none"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnIn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn_in.840264d9.svg";
export { ForwardRef as ReactComponent };